import React, { Fragment, useState, useContext, useEffect } from 'react';
import { CartContext } from 'components/cart';
import classNames from 'lib/classNames';



const AfterPay = ({ afterPay, price }) => {
    const {
        Utils,
        cart_settings: { money_format }
    } = useContext(CartContext);

    return (
        <div  >
            <div
                className={classNames('mb-1 split-payment-container flex flex justify-center items-center ')}
                style={{
                    fontSize: `${afterPay.text.font_size}em`,
                    color: Utils.formatColor(afterPay.text.color),
                    fontWeight: afterPay.text.font_weight,
                    textAlign: "center"
                }}
            >
                <span
                    dangerouslySetInnerHTML={{
                        __html: afterPay.text.text
                            .replace('{{split payment}}', afterPay.splits > 0 ? Utils.formatMoney(price / afterPay.splits, money_format) : '{{split payment}}')
                            .replace('{{installments}}', afterPay.splits)
                    }}
                />
                {!!afterPay?.image &&
                    <div className={classNames('rounded-full flex justify-center items-center m-2 overflow-hidden')} style={{ maxWidth: "80px", height: "20px" }} >
                        <img style={{ maxWidth: "80px", height: "20px" }} src={afterPay?.image} />
                    </div>
                }
            </div>
        </div>
    )
}

// ( ).toFixed(2)
export default AfterPay;